import React from 'react';
import { Mention, MentionsInput } from 'react-mentions';
import { useApolloClient } from 'react-apollo';
import { useField } from 'formik';
import { SEARCH_EXERCISES } from 'graphql/admin/curriculum';

const TextareaWithMention = ({ name, label, placeholder }) => {
  const client = useApolloClient();
  const [field, meta, helpers] = useField({ name });
  const onChange = (e, newVal, newPlainTextValue, mentions) => {
    helpers.setValue(newVal);
  };

  const renderUserSuggestion = (
    entry,
    search,
    highlightedDisplay,
    index,
    focused,
  ) => {
    return (
      <div className={`user ${focused ? 'focused' : ''}`}>
        {highlightedDisplay}
      </div>
    );
  };

  const onSearch = (query = '', cb) => {
    client
      .query({ query: SEARCH_EXERCISES, variables: { query: `%${query}%` }, fetchPolicy: "network-only" })
      .then(({ data }) => {
        const results = data.exercises.map((e) => ({
          id: e.id,
          display: `${e.name} from ${e.module.name}`,
        }));
        cb(results);
      });
  };

  return (
    <div>
      <MentionsInput
        style={styles}
        name={field.name}
        value={field.value}
        onChange={onChange}
        placeholder={placeholder}
      >
        <Mention
          trigger="@"
          data={onSearch}
          renderSuggestion={renderUserSuggestion}
          style={mentionStyle}
        />
      </MentionsInput>
    </div>
  );
};

const styles = {
  'control': {
    backgroundColor: '#fff',
    color: '#626C82',
    fontSize: 16,
    fontWeight: 'normal',
  },

  'highlighter': {
    overflow: 'hidden',
  },

  'input': {
    margin: 0,
  },

  '&singleLine': {
    control: {
      display: 'inline-block',

      width: 130,
    },

    highlighter: {
      padding: 1,
      border: '2px inset transparent',
    },

    input: {
      padding: 1,
      border: '2px inset',
    },
  },

  '&multiLine': {
    control: {
      borderBottom: '1px solid #626c82',
    },

    highlighter: {
      padding: 0,
    },

    input: {
      padding: 0,
      minHeight: 63,
      outline: 0,
      border: 0,
      lineHeight: 1.3,
    },
  },

  'suggestions': {
    list: {
      backgroundColor: 'white',
      border: '1px solid rgba(0,0,0,0.15)',
      fontSize: 14,
    },

    item: {
      'padding': '5px 15px',
      'borderBottom': '1px solid rgba(0,0,0,0.15)',

      '&focused': {
        backgroundColor: '#cee4e5',
      },
    },
  },
};

const mentionStyle = {
  fontSize: 16,
  backgroundColor: '#cee4e5',
  lineHeight: 1.3,
};

export default TextareaWithMention;
